import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Wallet, TrendingUp, HardHat } from 'lucide-react';

export default function InstallerCompensi() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.listInstallations();
        setItems(r.items || []);
      } catch (e) {
        toast.error(e?.response?.data?.detail || 'Errore caricamento');
      } finally { setLoading(false); }
    })();
  }, []);

  const totalDue = items.filter(i => i.compensation_status !== 'pagato').reduce((s, i) => s + Number(i.compensation_amount || 0), 0);
  const totalPaid = items.filter(i => i.compensation_status === 'pagato').reduce((s, i) => s + Number(i.compensation_amount || 0), 0);
  const totalGross = totalDue + totalPaid;

  return (
    <div>
      <PageHeader
        title="I miei Compensi"
        description="Riepilogo dei compensi maturati sugli interventi completati. Gli importi vengono impostati dallo staff Scintilla sulla base del tariffario per tipologia di prodotto installato."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        <Card><CardContent className="pt-4">
          <div className="text-xs text-muted-foreground flex items-center gap-1"><HardHat className="size-3.5" />Totale lordo</div>
          <div className="text-2xl font-semibold tabular-nums mt-1">€ {totalGross.toFixed(2)}</div>
        </CardContent></Card>
        <Card><CardContent className="pt-4">
          <div className="text-xs text-muted-foreground flex items-center gap-1"><Wallet className="size-3.5" />Da incassare</div>
          <div className="text-2xl font-semibold tabular-nums mt-1 text-orange-500">€ {totalDue.toFixed(2)}</div>
        </CardContent></Card>
        <Card><CardContent className="pt-4">
          <div className="text-xs text-muted-foreground flex items-center gap-1"><TrendingUp className="size-3.5" />Già incassato</div>
          <div className="text-2xl font-semibold tabular-nums mt-1 text-primary">€ {totalPaid.toFixed(2)}</div>
        </CardContent></Card>
      </div>

      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="p-10 text-center text-sm text-muted-foreground">Caricamento…</div>
          ) : items.length === 0 ? (
            <div className="p-10 text-center text-sm text-muted-foreground">Nessun compenso registrato</div>
          ) : (
            <Table>
              <TableHeader><TableRow>
                <TableHead>Intervento</TableHead>
                <TableHead>Cliente</TableHead>
                <TableHead>Stato intervento</TableHead>
                <TableHead className="text-right">Compenso</TableHead>
                <TableHead>Stato pagamento</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {items.map(it => {
                  const cust = it.customer_snapshot || {};
                  const custName = cust.customer_type === 'azienda' ? cust.company_name : `${cust.first_name || ''} ${cust.last_name || ''}`.trim();
                  return (
                    <TableRow key={it.id}>
                      <TableCell className="font-mono text-xs">{it.number || '—'}</TableCell>
                      <TableCell className="text-sm">{custName}</TableCell>
                      <TableCell><Badge variant="outline">{(it.status || '').replace('_', ' ')}</Badge></TableCell>
                      <TableCell className="text-right tabular-nums font-medium">€ {Number(it.compensation_amount || 0).toFixed(2)}</TableCell>
                      <TableCell><Badge variant={it.compensation_status === 'pagato' ? 'outline' : 'default'}>{it.compensation_status === 'pagato' ? 'Pagato' : 'Da pagare'}</Badge></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
      <div className="mt-3 text-xs text-muted-foreground">
        Nota: il tariffario compensi (fase 27b) permetterà a Scintilla di definire importi automatici per tipologia (es. FV 3kW = €150, batteria = €80). Per ora l'importo viene inserito manualmente sull'intervento.
      </div>
    </div>
  );
}
